module.exports = __webpack_public_path__ + "img/loader.481a2f24.gif";